export default "/_next/static/images/MembershipOnlyBG-c9ddf1860a78a003e2ff04e38bfbe14d.webp";